export interface SectionGroup<S> {
  /** Group id, or the section's own id when it has no group. */
  id: string;
  label: string;
  sections: S[];
}

/**
 * Sections arranged into groups, in their original order: a group sits where
 * its first section would. A section with no group becomes a group of one.
 */
export function groupSections<
  S extends { id: string; label: string; group?: string },
>(sections: S[], groupLabels: Record<string, string>): SectionGroup<S>[] {
  const groups: SectionGroup<S>[] = [];
  for (const section of sections) {
    if (!section.group) {
      groups.push({
        id: section.id,
        label: section.label,
        sections: [section],
      });
      continue;
    }
    const existing = groups.find(group => group.id === section.group);
    if (existing) {
      existing.sections.push(section);
      continue;
    }
    groups.push({
      id: section.group,
      label: groupLabels[section.group] ?? section.label,
      sections: [section],
    });
  }
  return groups;
}
